module.exports = __webpack_public_path__ + "static/media/icon_support.614674be.svg";